import httpClient from './httpClient'

export default {
  async createFolder(folder) {
    let ret = await httpClient.post('/folders', folder)
    return ret
  },
  async getUserFolders() {
    let url = '/folders?all_status=1'
    let ret = await httpClient.get(url)
    return ret
  },
  async getFolderVideos(folderId, getLogs) {
    let url = `/folders/${folderId}`
    if (getLogs) url += '?all_logs=1'
    let ret = await httpClient.get(url)
    return ret
  },
  async updateFolder(folder, folderId) {
    let ret = await httpClient.put(`/folders/${folderId}`, folder)
    return ret
  },
  async deleteFolder(folderId) {
    let ret = await httpClient.delete(`/folders/${folderId}`, {})
    return ret
  },
  async recoverDeletedFolder(folderId) {
    let ret = await httpClient.put(`/folders/${folderId}`, { status: true })
    return ret
  },
}
